<div class="id-card">
  <!-- Accent stripe -->
  <div class="card-stripe"></div>

  <!-- Header -->
  <div class="card-header">
    <span class="card-label">{{ 'PLAYER_ID' | translate }}</span>
    <span class="card-brand">Actively</span>
  </div>

  <!-- QR Section -->
  <div class="qr-section">
    @if (loading()) {
      <div class="qr-skeleton">
        <div class="shimmer"></div>
      </div>
    } @else if (qrDataUrl()) {
      <div class="qr-frame">
        <img
          [src]="qrDataUrl()"
          alt="Player ID QR Code"
          class="qr-image"
        />
      </div>
    } @else {
      <div class="qr-error">
        <span class="error-icon">!</span>
      </div>
    }
  </div>

  <!-- Player Info -->
  <div class="player-info">
    <span class="player-name">{{ userName }}</span>
    @if (shortId()) {
      <span class="player-code">{{ shortId() }}</span>
    }
  </div>

  <!-- Footer rule -->
  <div class="card-footer-rule"></div>
</div>
